import {Component, inject, input, OnChanges, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {
  MatDatepickerToggle,
  MatDateRangeInput,
  MatDateRangePicker,
  MatEndDate,
  MatStartDate
} from "@angular/material/datepicker";
import {MatFormField, MatHint, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatOption, MatSelect} from "@angular/material/select";
import {DateService} from "../../../services/date.service";
import {EmailTestingService} from "../../../services/email-testing.service";
import {IGamePlayerInputData} from "../../../interfaces/player/IGamePlayerInputData";
import {IEmailTemplateType} from "../../../interfaces/IEmailTemplateType";
import {emailAuditStatusOptions} from "../../../enum/EmailAuditStatusTypes";
import {
  EmailAuditTableComponent,
  EmailAuditTableFilter
} from "../../email-audit-table/email-audit-table.component";

@Component({
  selector: 'app-manage-player-sent-emails',
  standalone: true,
  imports: [
    EmailAuditTableComponent,
    MatButton,
    MatDateRangeInput,
    MatDateRangePicker,
    MatDatepickerToggle,
    MatEndDate,
    MatFormField,
    MatHint,
    MatLabel,
    MatOption,
    MatSelect,
    MatStartDate,
    MatSuffix,
    ReactiveFormsModule
  ],
  templateUrl: './manage-player-sent-emails.component.html'
})
export class ManagePlayerSentEmailsComponent implements OnInit, OnChanges {
  private dateService = inject(DateService);
  private emailTestingService = inject(EmailTestingService);

  public gamePlayerData = input.required<IGamePlayerInputData>();

  private playerId = '';
  private gameId: string | undefined;

  public emailTemplateTypes: IEmailTemplateType[] = [];
  public statusOptions = emailAuditStatusOptions;
  public filter: EmailAuditTableFilter | null = null;

  public emailTemplateTypeIdControl = new FormControl<number | null>(null);
  public statusControl = new FormControl<number | null>(null);
  public fromDateControl = new FormControl<Date>(this.dateService.twoWeeksAgo());
  public toDateControl = new FormControl<Date>(new Date());

  public filterFormGroup = new FormGroup({
    emailTemplateTypeId: this.emailTemplateTypeIdControl,
    status: this.statusControl,
    fromDate: this.fromDateControl,
    toDate: this.toDateControl
  });

  ngOnInit() {
    this.emailTestingService.getEmailTemplateTypes().subscribe(typesP => this.emailTemplateTypes = typesP);
  }

  ngOnChanges() {
    this.playerId = this.gamePlayerData().playerId;
    this.gameId = this.gamePlayerData().game?.Id;
    this.applyFilter();
  }

  onFilterClick() {
    this.applyFilter();
  }

  onResetClick() {
    this.filterFormGroup.reset({
      emailTemplateTypeId: null,
      status: null,
      fromDate: this.dateService.twoWeeksAgo(),
      toDate: new Date()
    });

    this.applyFilter();
  }

  // A new object each time, so the table sees the change and reloads.
  private applyFilter() {
    this.filter = {
      playerId: this.playerId,
      gameId: this.gameId,
      includePlatformEmails: true,
      emailTemplateTypeId: this.emailTemplateTypeIdControl.value,
      emailAuditStatusTypeId: this.statusControl.value,
      fromDate: this.fromDateControl.value ? new Date(this.fromDateControl.value) : undefined,
      toDate: this.toDateControl.value ? new Date(this.toDateControl.value) : undefined
    };
  }
}
